export default {
  logger: [
    {
      type: 'bunyan',
      name: 'first logger',
    },
    {
      type: 'winston',
      name: 'second',
    },
    {
      name: 'third ',
    },
  ],
};
